// extracted by mini-css-extract-plugin
export default {"seperator":"Accordion_seperator__5-hoh"};